const {
  atob, // Decodes a string of data which has been encoded using base-64 encoding.
  btoa, // Creates a base-64 encoded ASCII string from a "string" of binary data.
} = window;

export function encodeAuthToken(keyAuthorization: string, memberId: string) {
  const decodedString = [keyAuthorization, memberId].join(':');

  const encodedString = btoa(decodedString);

  return encodedString;
}

export function decodeAuthToken(encodedString: string) {
  const decodedString = atob(encodedString);

  const [keyAuthorization, memberId] = decodedString.split(':');

  return {
    keyAuthorization,
    memberId,
  };
}

export default {
  decodeAuthToken,
  encodeAuthToken,
};
